import { Dispatch } from 'redux';
import { FETCH_PAGE_REQUEST, FETCH_PAGE_SUCCESS } from '../../../routes/actions/types';
import { BOOKING } from '../../../routes/config/pageTypes';
import { ProcessingState } from '../../../routes/reducers/types';

export const SET_BOOKING_VALUE = 'SET_BOOKING_VALUE';
export const SET_BOOKING_VALIDITY = 'SET_BOOKING_VALIDITY';
export const BOOKING_PRICE_RECEIVE = 'BOOKING_PRICE_RECEIVE';
export const BOOKING_PRICE_FAIL = 'BOOKING_PRICE_FAIL';

export interface BookingValueAction {
  type: typeof SET_BOOKING_VALUE;
  name: string;
  value: number;
}

export interface BookingVadilityAction {
  type: typeof SET_BOOKING_VALIDITY;
  name: string;
  isValid: boolean;
}

export interface BookingPriceAction {
  type: typeof BOOKING_PRICE_FAIL;
}

export interface BookingPriceReceiveAction {
  type: typeof BOOKING_PRICE_RECEIVE;
  bookingPrice: number;
}

export type BookingPriceFetchAction = (dispatch: Dispatch) => void;

export interface BookingFetchPageRequest {
  type: typeof FETCH_PAGE_REQUEST;
  pageType: typeof BOOKING;
  location: string;
}

export interface BookingFetchPageSuccess {
  type: typeof FETCH_PAGE_SUCCESS;
  pageType: typeof BOOKING;
  data: {
    accommodation_id: number;
    arrival: string;
    duration_of_stay: number;
    location_ins: string;
    comment: string | null;
    payment_method: string;
    booking_id: number;
    amount: number;
    max_persons: number;
    current_persons: number;
    is_holiday_home: boolean;
  };
}

export default {
  SET_BOOKING_VALUE,
  SET_BOOKING_VALIDITY,
  BOOKING_PRICE_RECEIVE,
  BOOKING_PRICE_FAIL,
};
